import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import { phoneMask } from '../masks.js'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import DatePicker from '../../component/dccore-form/datePicker.vue'
import MoneyBoxHistory from '../../component/view/MoneyBoxHistory.vue'
import WalletHistory from '../../component/view/WalletHistory.vue'
import Moment from 'moment'
import Inputmask from 'inputmask'
import toastr from '../toastr'
import { CLIENT_DEFAULT_TYPE } from '@const/user'

if ($('#client_form').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#client_form',
    components: {
      RingLoader,
      Multiselect,
      TextInput,
      NumberInput,
      Singleselect,
      Checkbox,
      DatePicker,
      MoneyBoxHistory,
      WalletHistory
    },
    mixins: [mixins],
    data: {
      loading: 0,
      user: {
        plainPassword: {
          first: null,
          second: null
        },
        activated: false,
        brand: null,
        brandCurrencyCode: null,
        phone: '+48 ',
        marketingAgreement: false,
        commercialAgreement: false,
        needFv: false,
        nip: ''
      },
      errors: {
        plainPassword: {
          first: null,
          second: null
        }
      },
      moneyBoxErrors: {
        errors: {}
      },
      walletErrors: {
        errors: {}
      },
      deactivationErrors: {
        errors: {}
      },
      marketingDate: '',
      brands: [],
      sex: [],
      comingSource: [],
      clientTypes: [],
      moneyBoxFormLabel: '',
      moneyBoxForm: {
        newState: null,
        description: '',
        descriptionParams: {
          points: null,
        },
      },
      walletFormLabel: '',
      walletForm: {
        newState: null,
        description: '',
        descriptionParams: {
          points: null,
          currency: null
        },
      },
      userId: null,
      generatedPassword: '',
      defaultClientType: null,
    },
    watch: {
      'user.marketingDate': function (newValue) {
        if (Boolean(newValue) !== null) {
          let tmpDate = new Moment(newValue)
          this.marketingDate = tmpDate.format('LL')
        } else {
          this.marketingDate = null
        }
      },
      'user.marketingAgreement': function (newValue, oldValue) {
        if (typeof oldValue === 'undefined') {
          return
        }

        if (Boolean(newValue) === true) {
          this.user.marketingDate = new Date()
        } else {
          this.marketingDate = null
        }
      },
      'user.commercialAgreement': function (newValue, oldValue) {
        if (typeof oldValue === 'undefined') {
          return
        }

        if (Boolean(newValue) === true) {
          this.user.commercialDate = new Date()
        } else {
          this.commercialDate = null
        }
      },
      'user.email': function (newEmail) {
        /** Force lowercase */
        let lowerNewValue = newEmail.toLowerCase()
        if (lowerNewValue !== newEmail) {
          this.user.email = lowerNewValue
        }
      },
      'moneyBoxForm.newState': function (newState) {
        const points = String(Math.abs(newState))

        this.moneyBoxForm.descriptionParams.points = points

        if (newState >= 0) {
          this.moneyBoxForm.description = 'moneybox_log.service_add'
          this.moneyBoxFormLabel = `Dodanie ${points} punktów przez obsługę`
        } else {
          this.moneyBoxForm.description = 'moneybox_log.service_sub'
          this.moneyBoxFormLabel = `Odjęcie ${points} punktów przez obsługę`
        }
      },
      'walletForm.newState': function (newState) {
        const points = String(Math.abs(newState))
        const brandCurrencyCode = this.user.brandCurrencyCode

        this.walletForm.descriptionParams.points = points
        this.walletForm.descriptionParams.currency = brandCurrencyCode

        if (newState >= 0) {
          this.walletForm.description = 'wallet_log.service_add'
          this.walletFormLabel = `Dodanie ${points} ${brandCurrencyCode} przez obsługę`
        } else {
          this.walletForm.description = 'wallet_log.service_sub'
          this.walletFormLabel = `Odjęcie ${points} ${brandCurrencyCode} przez obsługę`
        }
      }
    },
    mounted: function () {
      let im = Inputmask(phoneMask)
      im.mask($('#form_phone')[0])

      this.loading++
      this.getBrands()
      this.getTags()
      if ($('#entity_id').length) {
        this.userId = $('#entity_id').val()
        this.getUser()
      }

      this.loading--
    },
    methods: {
      createClient: function (redirect) {
        let url = Routing.generate('api_post_client')

        let data = { data: Object.assign({}, this.user) }
        delete data.data.moneybox
        delete data.data.wallet
        this.loading++

        this.$http.post(url, data).then(response => {
          this.errors = {
            plainPassword: {
              first: null,
              second: null
            }
          }
          if (redirect) {
            $(location).attr('href', Routing.generate('client_show', { id: response.body.id }))
          } else {
            toastr.success(Translator.trans('form.created'))
          }
          this.loading--

        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      updateClient: function (redirect) {
        this.loading++

        let url = Routing.generate('api_patch_client', {
          id: this.userId
        })

        let data = { data: Object.assign({}, this.user) }
        delete data.data.moneybox
        delete data.data.wallet

        this.$http.patch(url, data).then(response => {
          this.errors = {
            plainPassword: {
              first: null,
              second: null
            }
          }
          if (redirect) {
            $(location).attr('href', Routing.generate('client_show', { id: response.body.id }))
          } else {
            toastr.success(Translator.trans('form.updated'))
          }
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getUser: function () {
        this.loading++
        let url = Routing.generate('api_get_client', { id: this.userId,
          context: 'edit' })

        this.$http.get(url).then(response => {
          let data = response.data
          data.plainPassword = {
            first: null,
            second: null
          }

          this.user = data
          if (!this.user.phone) {
            this.user.phone = '+48 '
          }

          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response)
        })
      },
      getBrands () {
        let url = Routing.generate('api_get_brands', { context: 'dropdown' })
        this.loading++

        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
      },
      getTags () {
        let url
        this.loading++
        url = Routing.generate('api_get_tags', { 'type': 'coming_source',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.comingSource = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
        this.loading++
        url = Routing.generate('api_get_tags', { 'type': 'sex',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.sex = response.data
          this.loading--
        }, response => {
          this.handleAjaxError(response)
        })
        this.loading++
        url = Routing.generate('api_get_tags', { 'type': 'client_type',
          context: 'dropdown' })
        this.$http.get(url).then(response => {
          this.clientTypes = response.data
          this.loading--
          if (!this.userId) {
            this.defaultClientType = this.getDefaultClientTypeId()
          }
        }, response => {
          this.handleAjaxError(response)
        })
      },
      generatePassword () {
        let password = Math.random().toString(36).slice(-8)
        this.generatedPassword = password
        this.user.plainPassword.first = password
        this.user.plainPassword.second = password
      },
      moneyboxForm () {
        $('#moneybox_form').slideToggle()
      },
      walletFormFunc () {
        $('#wallet_form').slideToggle()
      },
      toggleDeactivationForm() {
        $('#deactivation_form').slideToggle()
      },
      dismissMoneyBoxForm () {
        $('#moneybox_form').slideUp()
        this.moneyBoxForm.newState = null
        this.moneyBoxForm.description = ''
      },
      dismissWalletForm () {
        $('#wallet_form').slideUp()
        this.walletForm.newState = null
        this.walletForm.description = ''
      },
      deactivateClient() {
        this.loading++
        this.deactivationErrors.errors = {}

        let url = Routing.generate('api_patch_client_deactivation', {
          id: this.userId
        })

        this.$http.patch(url, {}).then(() => {
          $(location).attr('href', Routing.generate('client_show', { id: this.userId }))
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.deactivationErrors)
          this.toggleDeactivationForm()
        })
      },
      saveMoneyBoxForm () {
        this.moneyBoxErrors.errors = {}
        this.loading++

        let url = Routing.generate('api_patch_client_money_box', {
          id: this.userId
        })

        let data = { data: Object.assign({}, this.moneyBoxForm) }

        this.$http.patch(url, data).then(() => {
          this.dismissMoneyBoxForm()
          this.getUser()
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.moneyBoxErrors)
        })
      },
      saveWalletForm () {
        this.walletErrors.errors = {}
        this.loading++

        let url = Routing.generate('api_patch_client_wallet', {
          id: this.userId
        })

        let data = { data: Object.assign({}, this.walletForm) }

        this.$http.patch(url, data).then(() => {
          this.dismissWalletForm()
          this.getUser()
          this.loading--
        }, response => {
          this.loading--
          this.handleAjaxError(response, this.walletErrors)
        })
      },
      getDefaultClientTypeId() {
        let clientType = this.clientTypes.find((item) => {
          return item.systemValue === CLIENT_DEFAULT_TYPE
        })
        return clientType.id
      },
    }
  })
}
